export default __webpack_public_path__ + "static/media/topic-exam.345ffda5.svg";